export default {
  hexToRgb: (hex, opacity) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b
    })

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    if (result) {
      if (opacity) {
        return `rgba(${parseInt(result[1], 16)}, ${parseInt(result[1], 16)}, ${parseInt(result[1], 16)}, ${opacity})`
      } else {
        return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[1], 16)}, ${parseInt(result[1], 16)})`
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/color.helper.js